import { servicesImages } from '../../../utils/images';

export default function ServicesOverview() {
  const services = [
    {
      title: 'OEM & ODM MANUFACTURING',
      description:
        'Complete manufacturing solutions from concept to delivery, offering both Original Equipment Manufacturing and Original Design Manufacturing services for global fashion brands.',
      image: servicesImages.oemOdm,
    },
    {
      title: 'LEATHER DEVELOPMENT & FINISHING',
      description:
        'Expert leather processing and finishing services, from raw material selection to final treatment, ensuring premium quality and texture for all leather products.',
      image: servicesImages.leather,
    },
    {
      title: 'OUTERWEAR EXPERTISE',
      description:
        'Specialized in crafting premium outerwear including leather jackets, shearling coats, down jackets, and faux fur garments with exceptional attention to detail and quality.',
      image: servicesImages.outerwear,
    },
    {
      title: 'FLEXIBLE PRODUCTION',
      description:
        'Adaptable production capabilities ranging from small batch orders to large-scale manufacturing, meeting diverse client needs with efficient scalability and quick turnaround times.',
      image: servicesImages.production,
    },
    {
      title: 'GLOBAL TRADE SUPPORT',
      description:
        'Comprehensive international trade services including FOB terms, LDP arrangements, compliance management, and customs support to ensure smooth global transactions.',
      image: servicesImages.trade,
    },
  ];

  return (
    <section className="py-16 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-left mb-12 lg:mb-16">
          <div className="text-gray-600 text-sm font-light tracking-[0.2em] uppercase mb-6">
            OUR SERVICES
          </div>
          <h2 className="text-4xl lg:text-5xl font-light mb-8 leading-tight max-w-4xl">
            End to End Solutions, from Design to Delivery.
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-3 gap-6">
          {services.slice(0, 3).map((service, index) => (
            <div key={index} className="relative overflow-hidden">
              <div className="relative h-[500px] overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black text-white bg-opacity-40 flex flex-col justify-end p-8">
                  <div className="space-y-4">
                    <h3 className="text-lg font-bold tracking-wide leading-tight">
                      {service.title}
                    </h3>
                    <p className="text-xs leading-relaxed font-light opacity-90">
                      {service.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-8">
          {services.slice(3).map((service, index) => (
            <div key={index + 3} className="relative overflow-hidden">
              <div className="relative h-[500px] overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black text-white bg-opacity-40 flex flex-col justify-end p-8">
                  <div className="space-y-4">
                    <h3 className="text-lg font-bold tracking-wide leading-tight">
                      {service.title}
                    </h3>
                    <p className="text-xs leading-relaxed font-light opacity-90">
                      {service.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
